var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contentCont" },
    [
      _c("MyTable", {
        attrs: {
          "table-data": _vm.tableData,
          index: _vm.index,
          selection: _vm.selection,
          page: _vm.page,
          operation: _vm.operation,
          showpage: false,
          "table-option": _vm.tableOption,
        },
        on: {
          "update:tableOption": function ($event) {
            _vm.tableOption = $event
          },
          "update:table-option": function ($event) {
            _vm.tableOption = $event
          },
          "page-change": _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "menu",
            fn: function (scope) {
              return [
                _c(
                  "el-link",
                  {
                    attrs: { type: "primary", underline: false },
                    on: {
                      click: function ($event) {
                        return _vm.detailBtn(scope.row)
                      },
                    },
                  },
                  [_vm._v(" 详情 ")]
                ),
                _c(
                  "el-link",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "primary", underline: false },
                    on: {
                      click: function ($event) {
                        return _vm.editorBtn(scope.row)
                      },
                    },
                  },
                  [_vm._v(" 修改 ")]
                ),
                _c(
                  "el-link",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "primary", underline: false },
                    on: {
                      click: function ($event) {
                        return _vm.deleteBtn(scope.row)
                      },
                    },
                  },
                  [_vm._v(" 删除 ")]
                ),
              ]
            },
          },
          {
            key: "feeType",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(scope.row.feeType ? "自定义运费" : "商家承担运费")
                  ),
                ]),
              ]
            },
          },
          {
            key: "carriageAmount",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(scope.row.feeType ? scope.row.carriageAmount : "")
                  ),
                ]),
              ]
            },
          },
          {
            key: "freeShippingOrderAmount",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      scope.row.feeType ? scope.row.freeShippingOrderAmount : ""
                    )
                  ),
                ]),
              ]
            },
          },
          {
            key: "minOrderAmount",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(scope.row.feeType ? scope.row.minOrderAmount : "")
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }